import {useCallback, useEffect, useState} from "react";
import {optionAction} from "../../../../redux/store";
import {useDispatch, useSelector} from "react-redux";

const usePartChip = (itemObject) => {
  const dispatch = useDispatch();
  const configData = useSelector(state => state.optionWindow.CONFIG_DATA);

  const partChipSelectHandler = useCallback((code, item, switchData) => {

    const copyConfigData = {...configData[code]};

    const payloadKey = switchData?.partCategory || switchData?.type || item.switchKey || code
    const payloadCode = switchData?.code || item.code


    const payload = {
      key: payloadKey,
      value: {
        ...copyConfigData,
        CODE: payloadCode,
      }
    }
    dispatch(optionAction.setSendData(payload));
  },[configData]);


  const [switchData, setSwitchData] = useState();

  useEffect(() => {
    if(itemObject.partSwitch) {
      setSwitchData(itemObject.partSwitch);
    } else if(itemObject.materialSwitch) {
      setSwitchData(itemObject.materialSwitch);
    } else if(itemObject.partPersonalization) {
      setSwitchData(itemObject.partPersonalization);
    }
  },[itemObject]);


  return { partChipSelectHandler, switchData }

}
export default usePartChip;
